module.exports = __webpack_public_path__ + "img/Digital Identity logo.84fdec16.jpg";